import { LoadingRegion } from "./loading-region";
import { SkeletonAvatarSm, SkeletonLine, SkeletonBlock } from "./skeleton-primitives";
import { cn } from "@/lib/utils";

function ConversationRowSkeleton({ className }: { className?: string }) {
  return (
    <div className={cn("mx-2 my-1 flex w-[calc(100%-16px)] gap-3 rounded-xl p-3", className)}>
      <SkeletonAvatarSm />
      <div className="min-w-0 flex-1 space-y-2">
        <div className="flex justify-between gap-2">
          <SkeletonLine className="h-3.5 w-32" />
          <SkeletonLine className="h-3 w-14 shrink-0" />
        </div>
        <SkeletonLine className="h-3 w-24" />
        <SkeletonLine className="h-3 w-full max-w-[220px]" />
      </div>
    </div>
  );
}

export function ChatsConversationListSkeleton({
  className,
  labelKey = "chats.loadingChats",
}: {
  className?: string;
  /** i18n key for `sr-only` status (default: chats list). */
  labelKey?: string;
}) {
  return (
    <LoadingRegion busy labelKey={labelKey} className={cn("flex flex-col gap-0 py-4", className)}>
      {Array.from({ length: 8 }).map((_, i) => (
        <ConversationRowSkeleton key={i} />
      ))}
    </LoadingRegion>
  );
}

function MessageBubbleSkeleton({ align }: { align: "left" | "right" }) {
  return (
    <div className={cn("flex w-full", align === "right" ? "justify-end" : "justify-start")}>
      <SkeletonBlock className={cn("h-16 max-w-[72%]", align === "right" ? "rounded-2xl rounded-br-md" : "rounded-2xl rounded-bl-md")} />
    </div>
  );
}

export function ChatsMessageThreadSkeleton({
  className,
  labelKey = "chats.loadingMessages",
}: {
  className?: string;
  labelKey?: string;
}) {
  return (
    <LoadingRegion busy labelKey={labelKey} className={cn("flex h-full min-h-[200px] flex-col justify-end space-y-3 px-6 py-4", className)}>
      <MessageBubbleSkeleton align="left" />
      <MessageBubbleSkeleton align="right" />
      <MessageBubbleSkeleton align="left" />
      <MessageBubbleSkeleton align="right" />
    </LoadingRegion>
  );
}

export function ChatsOlderMessagesSkeleton() {
  return (
    <div className="flex justify-center py-2" aria-hidden>
      <div className="flex items-center gap-2">
        <SkeletonLine className="h-3 w-3 rounded-full" />
        <SkeletonLine className="h-3 w-36" />
      </div>
    </div>
  );
}
